import { LoanOfferMode } from '@shared/sec-loans'
import { usePageTitle } from '@ui-common/hooks/usePageTitle'
import { ExtraTightSectionContent } from '@ui-components/containers/ExtraTightSectionContent'
import { FormSectionContainer } from '@ui-components/form/FormSectionContainer'
import { LogoIconType } from '@ui-components/global/ComponentProps'
import { WizardStep } from '@ui-components/layout/WizardStep'
import { AdditionalText } from '@ui-components/typography/Typography'
import { useIntl } from 'react-intl'

import { MarketingSection } from '../../components/MarketingSection'
import { TheEndFooter } from '../../components/TheEndFooter'
import { resolveTheEndLabels } from '../../utils/helpers'
import { useExistingLoanOfferContext } from '../LoanOfferContext'
import { TheEndTopBar } from './TheEndTopBar'

export const TheEndStep = () => {
  const intl = useIntl()
  const { formatMessage } = intl
  const { loanOffer, user, goBack, goBackToStatus, exit } = useExistingLoanOfferContext()
  const { title, leadText } = resolveTheEndLabels({
    loanOfferMode: loanOffer.loanOfferMode,
    isBankCustomer: user.isBankCustomer,
    formatMessage,
  })
  const showBankerDetails = loanOffer.loanOfferMode === LoanOfferMode.Manual

  usePageTitle(title)

  return (
    <>
      <TheEndTopBar onBackConfirmed={goBackToStatus} exit={exit} formatMessage={formatMessage} />
      <WizardStep
        isLoading={false}
        title={title}
        icon={LogoIconType.SPankki}
        shouldShowMainHeader={false}
        pageIntro={{
          title,
          leadText,
        }}
        subHeaderOptions={{
          previousButtonProps: {
            label: formatMessage({ id: 'common-back' }),
            onClick: goBack,
          },
        }}
        customFooter={<TheEndFooter />}
      >
        {showBankerDetails && (
          <FormSectionContainer>
            <ExtraTightSectionContent>
              <AdditionalText>{formatMessage({ id: 'loan-offer-the-end-step-contact-greetings' })}</AdditionalText>
              <AdditionalText>{loanOffer.banker?.name}</AdditionalText>
              <AdditionalText>{formatMessage({ id: 'loan-offer-the-end-step-contact-position' })}</AdditionalText>
              {loanOffer.banker?.phoneNumber && (
                <AdditionalText>
                  {formatMessage(
                    { id: 'loan-offer-the-end-step-contact-phone' },
                    { phoneNumber: loanOffer.banker?.phoneNumber },
                  )}
                </AdditionalText>
              )}
            </ExtraTightSectionContent>
          </FormSectionContainer>
        )}
        <MarketingSection />
      </WizardStep>
    </>
  )
}
